import type { ButtonProps } from '@mui/material';
import { BookIcon } from '@src/shared/ui/icons';
import { forwardRef } from 'react';
import IconButton from './IconButton';

const BalanceIconButton = forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => {
    return (
      <IconButton ref={ref} {...props}>
        <BookIcon color="inherit" />
      </IconButton>
    );
  },
);

BalanceIconButton.displayName = 'BalanceIconButton';
export default BalanceIconButton;
